/**
 * Mirrors ProjulV1Portal's src/app/shared/Utils/estimate-logo-size.ts, minus the picker's
 * translation keys: this app only ever renders a logo at a size, it never offers the choice.
 */

export interface EstimateLogoSizeOption {
  key: number;
  sizeClass: string;
}

const SMALL: EstimateLogoSizeOption = { key: 1, sizeClass: 'LogoSmall' };
const MEDIUM: EstimateLogoSizeOption = { key: 2, sizeClass: 'LogoMedium' };
const LARGE: EstimateLogoSizeOption = { key: 3, sizeClass: 'LogoLarge' };

/** The three sizes, keyed as the portal writes them into the header override blob. */
export const estimateLogoSizes: readonly EstimateLogoSizeOption[] = [SMALL, MEDIUM, LARGE];

/** Medium is the 50pt every shared estimate already rendered at, so an absent size is unchanged. */
export const LOGO_SIZE_DEFAULT = MEDIUM.key;

/** An absent, null or unrecognised key resolves to the default rather than to no size at all. */
export function resolveLogoSize(key: number | null | undefined): EstimateLogoSizeOption {
  return estimateLogoSizes.find((option) => option.key === key) || MEDIUM;
}

export function logoSizeClass(key: number | null | undefined): string {
  return resolveLogoSize(key).sizeClass;
}
